import { currency } from '../../utils/helpers';
export default class PricingCalculator {
    static calculateTotal(options, useRegularPrice = false) {
        const { viewData, guestCounts, durationDays, groupBooking } = options;
        const adultPrice = useRegularPrice && viewData.regular_price !== undefined && viewData.regular_price !== null
            ? viewData.regular_price
            : viewData.adults_price;
        const weekdayPrice = this.getWeekdayPrice(viewData, options.reservationDate) || adultPrice;
        const baseAdultPrice = this.getPriceByPersonAmount(viewData, guestCounts.adults + guestCounts.teenagers + guestCounts.kids) || weekdayPrice;
        const baseTotal = groupBooking ? baseAdultPrice : (guestCounts.adults * baseAdultPrice) +
            (guestCounts.teenagers * viewData.teenagers_price) +
            (guestCounts.kids * viewData.kids_price);
        const guestTotal = viewData.dynamic_duration_days
            ? (baseTotal * durationDays)
            : baseTotal;
        const additionalServicesTotal = this.calculateAdditionalServices(guestCounts.adults + guestCounts.teenagers + guestCounts.kids, durationDays, viewData.dynamic_duration_days, options.additionalServicesSelector, options.formContainer || options.container);
        const finalTotal = Number(guestTotal) + Number(additionalServicesTotal);
        return {
            guestTotal,
            additionalServicesTotal,
            finalTotal
        };
    }
    static calculateGroupTotal(options) {
        const { viewData, guestCounts, durationDays, reservationDate } = options;
        const baseTotal = this.getWeekdayPrice(viewData, reservationDate) || viewData.adults_price;
        const guestTotal = viewData.dynamic_duration_days
            ? (baseTotal * durationDays)
            : baseTotal;
        const additionalServicesTotal = this.calculateAdditionalServices(guestCounts.adults + guestCounts.teenagers + guestCounts.kids, durationDays, viewData.dynamic_duration_days, options.additionalServicesSelector, options.formContainer || options.container);
        const finalTotal = Number(guestTotal) + Number(additionalServicesTotal);
        console.log('Group Total Calculation:', finalTotal);
        return {
            guestTotal,
            additionalServicesTotal,
            finalTotal
        };
    }
    static calculateAndUpdateTotal(totalElement, options) {
        const result = this.calculateTotal(options);
        if (totalElement) {
            totalElement.textContent = currency(result.finalTotal);
        }
        return result;
    }
    static calculateAndUpdateRegularTotal(regularTotalElement, options) {
        const result = this.calculateTotal(options, true);
        if (regularTotalElement) {
            regularTotalElement.textContent = currency(result.finalTotal);
        }
        return result;
    }
    static calculateAndUpdateGroupTotal(totalElement, options) {
        const result = this.calculateTotal(options, false);
        if (totalElement) {
            totalElement.textContent = currency(result.finalTotal);
        }
        return result;
    }
    static calculateAdditionalServices(totalGuests, durationDays, dynamicDurationDays, selector = 'input[type="radio"][name^="additional_services["]:checked', container) {
        let additionalServicesTotal = 0;
        const perDayMultiplier = dynamicDurationDays ? durationDays : 1;
        const searchRoot = container || document;
        const selectedAdditionalServices = searchRoot.querySelectorAll(selector);
        selectedAdditionalServices.forEach((input) => {
            const basePrice = parseFloat(input.getAttribute('data-price') || '0');
            const useOnce = input.getAttribute('data-use-once') === '1';
            const priceType = input.getAttribute('data-price-type') || 'per_person';
            const multiplier = useOnce ? 1 : perDayMultiplier;
            const totalPrice = priceType === 'group'
                ? basePrice * multiplier
                : basePrice * totalGuests * multiplier;
            additionalServicesTotal += totalPrice;
        });
        return additionalServicesTotal;
    }
    static getGuestCounts(container) {
        const adultInput = container.querySelector('#adults');
        const teenagerInput = container.querySelector('#teenagers');
        const kidInput = container.querySelector('#kids');
        return {
            adults: parseInt((adultInput === null || adultInput === void 0 ? void 0 : adultInput.value) || '0', 10),
            teenagers: parseInt((teenagerInput === null || teenagerInput === void 0 ? void 0 : teenagerInput.value) || '0', 10),
            kids: parseInt((kidInput === null || kidInput === void 0 ? void 0 : kidInput.value) || '0', 10)
        };
    }
    static getDurationDays(container, viewData) {
        const durationInput = container.querySelector('#duration_days');
        return durationInput
            ? parseInt(durationInput.value || '1', 10)
            : (viewData.duration_days || 1);
    }
    static getWeekdayPrice(viewData, reservationDate) {
        let price = null;
        if (!viewData.price_by_weekday || !reservationDate) {
            return price;
        }
        const date = new Date(reservationDate);
        const weekday = date.getDay() === 0 ? 7 : date.getDay(); // 0 (Sunday) to 6 (Saturday) - add Sunday as 7th day
        Object.values(viewData.price_by_weekday).forEach((item) => {
            if (parseInt(item.weekday) === weekday) {
                price = item.price;
                return;
            }
        });
        return price;
    }
    static getPriceByPersonAmount(viewData, guests) {
        let price = null;
        if (viewData.price_by_person_amount) {
            Object.values(viewData.price_by_person_amount).forEach((item) => {
                if (guests >= item.min && (item.max === null || guests <= item.max)) {
                    price = item.price;
                    return;
                }
            });
        }
        return price;
    }
}
